import { DefaultValidationTheme } from '@uservoice/theme-configs';

const theme = new DefaultValidationTheme();

export default theme;
